export const viewTitle = "Внешнее API - пользователи";
export const viewUniqKey = "externalApi";
